<template>
  <div>
    <ul class="content-normal" v-if="data && data.length">
      <li @click="view(v)" v-for="(v, k) of data" :key="k" class="works-items">
        <x-image class="cover" :size="59" el="div" :img-src="v.work_info[0].preview_url" />
        <div class="content">
          <h5>{{v.package_name}}</h5>
          <h5>{{v.lesson_name}}</h5>
          <p class="date">{{v.updated_at | date('Y/m/d')}}</p>
        </div>
      </li>
    </ul>

    <div v-else class="no-data">
      <img src="https://public-static-edu.codemao.cn/redboat/learningStatistics/no-data.png" />
      <span>暂无成长档案</span>
    </div>
  </div>
</template>

<script>
import XImage from '@/components/XImage'
import { post } from '@/utils/ajax'

export default {
  components: {
    XImage
  },
  data () {
    return {
      data: null,
      active: 0
    }
  },
  methods: {
    async refresh () {
      const res = await post(`/edu/zone/growth/student/profile/all`)
      this.data = res
    },
    view (val) {
      this.$router.push({ name: 'viewGrowthFile', query: { student_profile_id: val.student_profile_id } })
    }
  },
  mounted () {
    this.refresh()
  }
}
</script>

<style lang="stylus" scoped>
.works-items {
  min-height: 80px;
  padding-top: 20px;
  padding-bottom: 14px;
  flex-shrink: 0;
  display: flex;
  // border-1('%23f6f6f6', bottom)
  border-bottom: 1px solid #f6f6f6;

  &:last-child {
    border-bottom: 0;
  }

  .cover {
    width: 80px;
    height: 80px;
    margin-right: 15px;
    border-radius: 8px;
  }

  h5 {
    color: #333;
    margin-bottom: 10px;
    font-size: 16px;
  }

  p {
    color: #999;
  }

  .no-start {
    margin-bottom: 0;
    color: #feb210;
  }
}

.no-data {
  font-size: 14px;
  color: #666;
  text-align: center;
  margin: 40% auto 0;
  width: 180px;

  img {
    width: 100%;
    height: 100%;
    display: block;
    margin-bottom: 25px;
  }
}
</style>
